import { observable } from "mobx";
import { Type } from "class-transformer";
import AppendixListAppendixesItem from "./appendixListAppendixesItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AppendixList {
  @observable
  total!: number;

  @observable
  @Type(() => AppendixListAppendixesItem)
  appendixes!: AppendixListAppendixesItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    appendixes: { required: true },
  };
}
